import HeaderActionBar from '../HeaderActionBar/HeaderActionBar'
import classes from './Friends.module.css'
import { useDispatch, useSelector } from 'react-redux';
import myTeam from '../../../../assests/dashboard/friends/my-team-icon.png'
import projectsSentToMe from '../../../../assests/dashboard/friends/projectsSentToMe.png'
import nationalCooperatives from '../../../../assests/dashboard/friends/national-cooperatives.png'
import { useEffect, useMemo, useState } from 'react';
import { participantsApi, postsApi } from "../../../../utils";
import LessonsBtnMenu from '../Lessons/LessonsBtnMenu';
import { useParams } from 'react-router-dom';
import { throwApiError } from '../../../lms-shared/store/error-handling-actions';
import { ParticipantTypeEnumText } from "../../../../models/ParticipantTypeEnum";
import Participants from './Participants';
import Posts from './Posts';
import { ObjectTypeEnumText } from '../../../../models/ObjectTypeEnum';
import PostPopUp from './Share/PostPopUp';
import { TargetObjectIdEnum } from '../../../../models/TargetObjectIdEnum';
import { onKeyDown } from '../../../../service';

const Friends = () => {
    const { direction, texts } = useSelector(state => state.translate);
    const { user } = useSelector(state => state.auth);
    const [currentPostType, setCurrentPostType] = useState(0)
    const [currentParticipant, setCurrentParticipant] = useState(0)
    const { studyGroupId } = useParams();
    const dispatch = useDispatch();
    const btnList = useMemo(() => [{ text: texts.nationalCooperatives, icon: nationalCooperatives }, { text: texts.projectsSentToMe, icon: projectsSentToMe }, { text: texts.myTeam, icon: myTeam }], [])
    const [data, setData] = useState()
    const [message, setMessage] = useState(null)
    const [projectData, setProjectData] = useState(null)
    const [clickShowShareProjectPopup, setClickShowShareProjectPopup] = useState(false)
    const [currentPosts, setCurrentPosts] = useState({ posts: null, pageNum: 0, noMore: false })
    const [newPost, setNewPost] = useState(true)
    const [isFetching, setIsFetching] = useState(false);

    const studyGroup = useSelector(state => state.topics.studyGroup);

    const PostTypeEnum = {
        national: 0,
        projectsSentToMe: 1,
        participants: 2,
        specificFriends: 3,
        external: 4
    }

    useEffect(() => {
        let myData = {
            studyGroupId: studyGroupId,
            participantType: ParticipantTypeEnumText.student,
        }
        if (studyGroup && !studyGroup.allowSelfRegister) {
            participantsApi.participantsFilterRangePost({ participantsRangeFilter: myData }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.participantsAddError, error: error, statusCode: response?.statusCode, message: "participantsAddPost " + error.message, level: 2, component: "CurriculumPage", line: 36 }))
                }
                else {
                    setData(response.body)
                }
            })
        }
    }, [studyGroup])

    useEffect(() => {
        (async () => {
            let res = await fetchPostData(0);
            setCurrentPosts({ posts: res, pageNum: 0, noMore: false });
        })()

    }, [currentPostType, currentParticipant])

    useEffect(() => {
        if (clickShowShareProjectPopup) {
            setMessage(<PostPopUp
                changePosts={(p) => changePostsFunc(p)}
                myHeight={'446px'}
                setProjectData={(p) => setProjectData(p)}
                project={projectData}
                beenSharedBefore={false}
                setBeenSharedBefore={prev => !prev}
                close={() => setMessage(false)}
                newPost={newPost}
                setNewPost={setNewPost}
                setClickShowShareProjectPopup={setClickShowShareProjectPopup}
                friendsData={data}
            />)
        }
    }, [projectData, clickShowShareProjectPopup])

    function changePostsFunc(p) {
        p.contentData = JSON.parse(p.contentData)
        p.user = user
        if ((p.shares[0].targetObjectType === "ConstUserGroup" && currentPostType === PostTypeEnum.national) || (p.shares[0].targetObjectType === "StudyGroup" && currentPostType === PostTypeEnum.participants) || (p.shares[0].targetObjectType === "User" && currentPostType === PostTypeEnum.specificFriends)) {
            setCurrentPosts({ ...currentPosts, posts: [p, ...currentPosts.posts] })
        }
    }

    async function setCurrentPostsInUseEffect() {
        let res = await fetchPostData(currentPosts.pageNum + 1);
        setCurrentPosts(preCurrentPosts => {
            let newCurrentPosts = [...preCurrentPosts.posts];
            let ids = newCurrentPosts.map(p => p.id)
            if (res && res.length > 0) {
                res.forEach(p => {
                    if (!ids.includes(p.id)) {
                        newCurrentPosts.push(p);
                    }
                });
            }
            return { posts: newCurrentPosts, pageNum: preCurrentPosts.pageNum + 1, noMore: !(res && res.length > 0) };
        });
    }

    const fetchPostData = (page) => new Promise((resolve) => {
        if (isFetching) return;
        let data = {}
        if (currentPostType == PostTypeEnum.national) {
            data = {
                targetObjectType: ObjectTypeEnumText.ConstUserGroup,
                pageNum: page,
                targetObjectId: TargetObjectIdEnum.ConstUserGroup,
                rowsNum: 15
            }
        }
        else if (currentPostType == PostTypeEnum.projectsSentToMe) {
            data = {
                targetObjectId: user.id,
                targetObjectType: ObjectTypeEnumText.User,
                pageNum: page,
                rowsNum: 15
            }
        }
        else {
            if (currentParticipant) {
                if (user.id == currentParticipant) {
                    data = {
                        sourceObjectId: currentParticipant,
                        sourceObjectType: ObjectTypeEnumText.User,
                        pageNum: page,
                        rowsNum: 15
                    }
                }
                else {
                    data = {
                        sourceObjectId: currentParticipant,
                        sourceObjectType: ObjectTypeEnumText.User,
                        targetObjectType: ObjectTypeEnumText.StudyGroup,
                        targetObjectId: studyGroupId,
                        pageNum: page,
                        rowsNum: 15
                    }
                }

            }
            else {
                data = {
                    targetObjectType: ObjectTypeEnumText.StudyGroup,
                    targetObjectId: studyGroupId,
                    pageNum: page,
                    rowsNum: 15
                }
            }
        }
        setIsFetching(true);
        postsApi.postsFilterRangePost({ postsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                setIsFetching(false);
                dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "postsFilterRangePost " + error.message, level: 1, component: "Friends", line: 168 }))
            }
            else {
                setIsFetching(false);
                resdata.sort((a, b) => new Date(a.updatedDate) - new Date(b.updatedDate));
                resdata = resdata.map(p => {
                    try {
                        let contentData = JSON.parse(p.contentData);
                        p.contentData = contentData;
                    }
                    catch {
                        p.contentData = null
                    }
                    return p;
                })
                resolve(resdata.reverse())
            }
        })
    })

    function shareProject() {
        setProjectData(null)
        setClickShowShareProjectPopup(true)
    }

    const handeleSaveEditChanges = (post) => {
        let myPosts = currentPosts.posts
        const target = myPosts.find((obj) => obj.id === post.id);
        Object.assign(target, post);
        console.log('myPosts', myPosts);
        setCurrentPosts({ ...currentPosts, posts: myPosts })
    }
    return (
        <div>
            {message}
            <HeaderActionBar />
            <div className={classes.HeaderContainer}>
                <div className={classes.Header} onClick={shareProject} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, shareProject)}>
                    <div className={classes.AddPostText}>{texts.shareSomething}</div>
                    <div className={classes.AddIcon}>+</div>
                </div>
            </div>
            <div className={classes.FriendsContainer}>
                <div className={`${classes[direction]} ${classes.TabsContainer}`}>
                    <div className={classes.TabsDirection}>
                        <LessonsBtnMenu setNochildChosen={setCurrentParticipant} childIsChosen={currentParticipant} btnList={btnList} currentBtn={currentPostType} changeBtn={(newCurrentBtn) => setCurrentPostType(newCurrentBtn)} HiddenText={true} />
                        {currentPostType === PostTypeEnum.participants && <div> <Participants data={data} currentParticipant={currentParticipant} setCurrentParticipant={setCurrentParticipant}></Participants></div>}
                    </div>
                </div>

                <Posts
                    currentParticipant={currentParticipant}
                    currentPostType={currentPostType}
                    PostTypeEnum={PostTypeEnum}
                    setCurrentPostsInUseEffect={setCurrentPostsInUseEffect}
                    changePosts={(newP) => setCurrentPosts({ ...currentPosts, posts: currentPosts.posts.filter(cp => cp.id != newP) })}
                    currentPosts={currentPosts}
                    handeleSaveEditChanges={handeleSaveEditChanges}
                    friendsData={data}
                />

            </div>
        </div >
    )
}
export default Friends